import React, {Component} from 'react';
import Chart from 'chart.js';
import './styles.css';
import PropTypes from 'prop-types';

class DoughnutChart extends Component {

    componentWillUnmount() {
        this.DoughnutChart.destroy();
    }

    componentDidMount() {
        var ctx = document.getElementById(this.props.id).getContext("2d");
        this.DoughnutChart = new Chart(ctx, {
            type: 'doughnut',
            data: this.props.data,
            options: this.props.options
        });
    }

    render() {
        return (<canvas id={this.props.id} />);
    }
}

DoughnutChart.propTypes = {
    data: PropTypes.object,
    options: PropTypes.object,
    id: PropTypes.string,
    style: PropTypes.object,
};

DoughnutChart.defaultProps = {
    data: {},
    options: {},
    id: 'chart-area',
    style: {},
};


export default DoughnutChart;






// WEBPACK FOOTER //
// ./src/components/DoughnutChart/index.js